export default "__VITE_ASSET__CzQiKdB___"